<template lang="pug">
.study-result-detail-image-list(:data-role='userRole')
  .study-result-detail-image-list__inner
    .study-result-detail-image-list__inner__content(:style='setStyle')
      template(v-for='image in images')
        link-base.study-result-detail-image-list__inner__content__thumbnail(@click='clickEvent(image)')
          image-base.study-result-detail-image-list__inner__content__thumbnail__image(:src='image.thumbnail')
          image-base.study-result-detail-image-list__inner__content__thumbnail__icon(
            :src='require(`@/assets/img/common/icon/${iconName(image)}.svg`)'
          )
          span.study-result-detail-image-list__inner__content__thumbnail__text(v-if='!image.isSolved') 未実施の問題です
  .study-result-detail-image-list__button-prev(v-if='showPrev', @click='movePrev')
    image-base.study-result-detail-image-list__button-prev__icon(:src='require("@/assets/img/common/icon/prev.svg")')
  .study-result-detail-image-list__button-next(v-if='showNext', @click='moveNext')
    image-base.study-result-detail-image-list__button-next__icon(:src='require("@/assets/img/common/icon/next.svg")')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import LinkBase from '@/components/atoms/LinkBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import { StudyResultDetailImage } from '@/models/studyResultDetailModel'
import { UserRoles } from '@/const/UserRoles'
import { ImageListSetting } from '@/const/DisplaySettings'

/**
 * テスト履歴詳細キャプチャ画像一覧
 */
@Component({
  components: {
    LinkBase,
    ImageBase,
  },
})
export default class StudyResultDetailImageList extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // 画像情報
  @Prop()
  images!: StudyResultDetailImage[]

  // 画像クリック時イベント
  @Prop()
  clickEvent!: Function

  // 先頭に表示している画像のindex値
  private topImageIndex = 0

  // 正否アイコン名
  private iconName(image: StudyResultDetailImage): string {
    return image.isCorrect ? 'correct' : 'wrong'
  }

  // 戻るボタンの挙動
  private movePrev() {
    // 先頭画像indexから表示画像数を引く（0以下の場合は0を設定）
    const index = this.topImageIndex - ImageListSetting.NUMBER_TO_DISPLAY
    this.topImageIndex = index > 0 ? index : 0
  }

  // 進むボタンの挙動
  private moveNext() {
    // 先頭画像indexに表示画像数を足す（最大index以上の場合は最大indexを設定）
    const index = this.topImageIndex + ImageListSetting.NUMBER_TO_DISPLAY
    this.topImageIndex = index < this.maxTopIndex ? index : this.maxTopIndex
  }

  // 先頭画像indexの最大値
  private get maxTopIndex(): number {
    return this.images.length - ImageListSetting.NUMBER_TO_DISPLAY
  }

  // 戻るボタン表示フラグ
  private get showPrev(): boolean {
    return this.topImageIndex > 0
  }

  // 進むボタン表示フラグ
  private get showNext(): boolean {
    return this.topImageIndex < this.maxTopIndex
  }

  // 先頭画像indexをスタイルにセットする
  private get setStyle(): { [key: string]: string } {
    return {
      '--top-image-index': `${this.topImageIndex}`,
    }
  }
}
</script>

<style lang="stylus" scoped>
.study-result-detail-image-list
  position relative
  display flex
  width 100%
  height 100%
  background var(--color-manager-image-list__background)
  padding 10px

  &__inner
    overflow-x hidden
    overflow-y hidden

    &__content
      display flex
      align-items flex-start
      gap 20px
      // 先頭画像indexに幅と余白の合計値（230 + 20）を掛け合わせた値分左に移動
      transform translate(calc(var(--top-image-index) * -250px))
      transition 0.3s ease-out

      &__thumbnail
        position relative
        display flex

        &__image
          width 230px
          height 180px
          max-width unset

        &::before
          position absolute
          content ''
          width 100%
          height 100%
          background var(--color-manager-image-list__image-hover)
          opacity 0

        &:hover
          &::before
            opacity 1

        &__icon
          position absolute
          top 5px
          left 5px
          width 38px
          height 38px

        &__text
          color: red
          background: white
          font-weight: bold
          position absolute
          top 15px
          left 50px

  &__button-prev,
  &__button-next
    position absolute
    top 80px
    display flex
    align-items center
    justify-content center
    width 60px
    height 60px
    border-radius 300px
    background var(--button-background)
    cursor pointer

  &__button-prev
    left -30px

  &__button-next
    right -30px

  &[data-role='academy']
    --button-background var(--color-manager-image-list-button-academy__background)
  &[data-role='branch']
    --button-background var(--color-manager-image-list-button-branch__background)
</style>
